function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M 7.8125 4 C 7.335938 4.089844 6.992188 4.511719 7 5 L 7 45 C 7 45.550781 7.449219 46 8 46 L 42 46 C 42.550781 46 43 45.550781 43 45 L 43 5 C 43 4.449219 42.550781 4 42 4 L 8 4 C 7.96875 4 7.9375 4 7.90625 4 C 7.875 4 7.84375 4 7.8125 4 Z M 9 6 L 41 6 L 41 44 L 9 44 Z M 14 12 L 14 14 L 17 14 L 17 12 Z M 20 12 L 20 14 L 37 14 L 37 12 Z M 14 20 L 14 22 L 17 22 L 17 20 Z M 20 20 L 20 22 L 37 22 L 37 20 Z M 14 28 L 14 30 L 17 30 L 17 28 Z M 20 28 L 20 30 L 37 30 L 37 28 Z M 14 36 L 14 38 L 17 38 L 17 36 Z M 20 36 L 20 38 L 37 38 L 37 36 Z",
  fill: "#18181b"
});

var SvgInsurance = function SvgInsurance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "#18181b",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInsurance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/insurance.5a22821d.svg";
export { ForwardRef as ReactComponent };